import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  create_service_detail,
  update_service_detail,
  update_service_detail_image,
} from '@/api/mjstore-model';

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
export const event_obj = mitt();
export const btn_list = [
  {
    name: '编辑',
    clazz: 'primary',
    type: 'dropdown',
    cb: (data: any) => {
      // const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '服务过程',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'input',
              name: 'service_note',
              label: '服务记录/诊断记录',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写服务记录/诊断记录',
            },
            {
              type: 'input',
              name: 'note',
              label: '注意事项',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写注意事项',
            },
            {
              type: 'input',
              name: 'customer_feedback',
              label: '客户体验反馈',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写客户体验反馈',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '记录时间',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: false,
              format: 'YYYY-MM-DD HH:mm:ss',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
              placeholder: '请填写记录时间',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '记录执行门店',
              disabled: true,
              placeholder: '请选择记录执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '记录执行人',
              disabled: false,
              placeholder: '请选择记录执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {},
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            service_detail_id: data.id,
            note: data.note,
            service_note: data.service_note,
            customer_feedback: data.customer_feedback,
            date: data.date,
            shop_id: data.shop_id,
            staff_id: data.staff_id,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            update_service_detail(payload)
              .then(() => {
                message.success('编辑服务信息成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '上传服务前照片',
    clazz: 'primary',
    type: 'dropdown',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const loading = ref(false);
      const editModal = reactive({
        visible: true,
        title: '服务前',
        group: 'mj',
        component: 'upload-image-modal',
        loading: loading,
        ok: (payload: any) => {
          return new Promise(resolve => {
            loading.value = true;
            update_service_detail_image({
              service_detail_id: data.id,
              image_update_type: 'add',
              ids: payload,
              image_type: 'before',
              org_id: current_org?.id,
            })
              .then(() => {
                message.success('添加成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                loading.value = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '上传服务后照片',
    clazz: 'primary',
    type: 'dropdown',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const loading = ref(false);
      const editModal = reactive({
        visible: true,
        title: '服务后',
        group: 'mj',
        component: 'upload-image-modal',
        loading: loading,
        ok: (payload: any) => {
          return new Promise(resolve => {
            loading.value = true;
            update_service_detail_image({
              service_detail_id: data.id,
              image_update_type: 'add',
              ids: payload,
              image_type: 'after',
              org_id: current_org?.id,
            })
              .then(() => {
                message.success('添加成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                loading.value = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '编辑照片',
    clazz: 'primary',
    type: 'dropdown',
    cb: (data: any) => {
      const loading = ref(false);
      const editModal = reactive({
        visible: true,
        title: '编辑照片',
        group: 'mj',
        component: 'double-image-edit-modal',
        before_image_list: data.before_image_json,
        after_image_list: data.after_image_json,
        obj: data,
        loading: loading,
        ok: (payload: any) => {
          if (payload) {
            Object.assign(data, payload);
          }
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [];
